module.exports = __webpack_public_path__ + "img/store.e603a76.svg";